import {Component, Inject, OnInit} from '@angular/core';
import {Iframe} from "../iframe";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

export interface IframeDialogData {
    iframe: Iframe;
}

@Component({
    selector: 'cms-iframe-dialog',
    templateUrl: './iframe-dialog.component.html',
    styleUrls: ['./iframe-dialog.component.scss'],
    standalone: false
})
export class IframeDialogComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<IframeDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IframeDialogData
    ) {
    }

  ngOnInit() {
  }

}
